<div class="overlapped-background-block"></div>

@if (options$ | async; as options) {
  <ng-lottie
    [width]="width"
    [height]="height"
    [options]="options"
    (animationCreated)="animationCreated.emit($event)"
  ></ng-lottie>
}
